import { getLogger } from 'utils/logger';

import buildUser from './user';
import { initializeLdClient } from './initialize';

const log = getLogger('featureFlags/identify');

export function featureFlagsIdentifyUser(authSession) {
  if (!authSession || !authSession.qcsId) {
    return;
  }

  const user = buildUser(authSession);
  if (!window.ldClient) {
    initializeLdClient(user);
  }
  else {
    log.info('LaunchDarkly - Updating with', user);
    try {
      window.ldClient.identify(user, null, () => { });
    } catch (e) {
      log.error('Exception when updating user in LaunchDarkly', e);
    }
  }
}
